import { useCallback } from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Returns a `pick(item, fieldName)` function that resolves to the
 * EN variant when language is "en" (with UA fallback), otherwise the UA value.
 *
 * Convention: EN field names are `${field}En` (e.g. `name` ↔ `nameEn`).
 *
 *   const pick = useLocalizedField();
 *   pick(member, 'name'); // member.nameEn || member.name (in EN), member.name (in UA)
 */
export const useLocalizedField = () => {
    const { language } = useLanguage();

    return useCallback((item, field) => {
        if (!item) return '';
        if (language === 'en') return item[field + 'En'] || item[field] || '';
        return item[field] || '';
    }, [language]);
};

